<script>
  import ChatConversaMensagem from './ChatConversaMensagem'
  import ChatService from '../../../domain/chat/services/chat'

  export default {
    props: ['currentUser', 'destUser'],
    name: 'chat-conversa',
    data () {
      return {
        mensagens: [],
        mensagem: '',
        shakeChat: false,
        isFocus: false,
        isLoading: false,
        isLoadingSend: false
      }
    },
    computed: {
      buildMensagens () {
        let mensagens = []
        if (this.mensagens.length === 0) {
          return []
        }
        let last = 0
        for (let i = 0; i < this.mensagens.length; ++i) {
          mensagens.push(this.mensagens[i])
          mensagens[i].showAvatar = false
          mensagens[i].startMessage = false
          if (i === 0) {
            mensagens[i].startMessage = true
            continue
          }
          if (last !== this.mensagens[i].remetente.id) {
            mensagens[i - 1].showAvatar = true
            mensagens[i].startMessage = true
          }
          if (i === this.mensagens.length - 1) {
            mensagens[i].showAvatar = true
          }
          last = this.mensagens[i].remetente.id
        }
        return mensagens
      }
    },
    mounted () {
      this.loadMessages()
      this.audioMessage = new Audio('https://www.wtis.com.br/audios/mensagem.mp3')
      this._keyListener = this.$el.addEventListener('keyup', (pKey) => {
        if (pKey.key.toLowerCase() === 'escape') {
          this.close()
        }
      })
      this.focusChat()
    },
    destroyed () {
    },
    methods: {
      shake () {
        this.shakeChat = true
        window.setTimeout(() => {
          this.shakeChat = false
        }, 1000)
      },
      close () {
        this.$emit('close', this.destUser)
      },
      focusChat () {
        this.$nextTick(() => {
          let divMessages = this.$el.querySelector('.messages')
          divMessages.scrollTop = divMessages.scrollHeight - divMessages.clientHeight
          this.$refs.inputMessage.focus()
        })
        // this.isFocus = true
      },
      loadMessages (onlyNotReads) {
        onlyNotReads = typeof onlyNotReads !== 'undefined'
        if (!onlyNotReads) {
          this.isLoading = true
        }
        ChatService.loadMessages(this.destUser.id, null, onlyNotReads).then(result => {
          if (onlyNotReads) {
            console.log(result.data)
            this.mensagens = this.mensagens.concat(result.data)
          } else {
            this.mensagens = result.data
          }
          this.isLoading = false
          this.$nextTick(() => {
            // Desce o scroll
            this.focusChat()
          })
        })
          .catch(error => {
            this.isLoading = false
            console.log(error)
          })
      },
      reload () {
        this.loadMessages(true)
      },
      enviaMensagem () {
        if (this.mensagem.length === 0) {
          return
        }
        let _mensagem = JSON.parse(JSON.stringify(this.mensagem))
        this.mensagem = ''
        this.isLoadingSend = true
        ChatService.sendMessage(this.destUser.id, null, {mensagem: _mensagem}).then(result => {
          this.audioMessage.play()
          this.mensagens.push(result.data)
          this.focusChat()
          this.isLoadingSend = false
        })
          .catch(error => {
            this.isLoadingSend = false
            console.log(error.response)
          })
      }
    },
    components: {ChatConversaMensagem}
  }
</script>

<template>
  <div class="chat-conversa" :class="{'shake-active': shakeChat, 'isFocus': isFocus}">
    <div class="top">
      <span class="rementente">{{ destUser.nome }}</span>
      <span class="actions"><a @click="close" class="btn btn-xs"><i class="fa fa-times"></i> </a> </span>
    </div>
    <div class="messages">
      <div v-if="isLoading" class="conversa-loading"><i class="fa fa-spin fa-spinner"></i></div>
      <chat-conversa-mensagem v-for="m in buildMensagens" :key="m.id" :mensagem="m"
                              :currentUser="currentUser"></chat-conversa-mensagem>

    </div>
    <div class="send">
      <input @keyup.enter="enviaMensagem" v-model="mensagem" ref="inputMessage"
             placeholder="Digite uma mensagem" class="no-shortkey" /> <!-- :disabled="isLoadingSend" -->
    </div>
  </div>
</template>

<style lang="scss">
  .chat-conversa {
    direction: ltr;
    position: relative;
    top: -321px;
    width: 257px;
    height: 320px;
    background-color: #FFFFFF;
    margin-left: 10px;
    -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.50);
    -moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.50);
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.50);
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    overflow: hidden;
    display: inline-flex;
    flex-direction: column;
    justify-content: space-between;
    font-family: Arial;
    .conversa-loading {
      text-align: center;
    }
    .msg {
      font-size: 14px;
    }
    &.isFocus {
      .top {
        background: #4080ff;
        color: #FFFFFF;
      }
    }
    .top {
      width: 100%;
      display: flex;
      align-items: center;
      padding: 0 10px;
      height: 34px;
      background: #f6f7f9;
      box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .20);
      justify-content: space-between;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      cursor: default;
      .remetente {
        flex: 1;
        white-space: nowrap;
        text-overflow: ellipsis; // TODO: Testar nome grande
      }
      .actions {
        flex: 0;
      }
    }
    .messages {
      max-height: 100%;
      overflow: auto;
      padding: 16px;
    }
    .send {
      flex: 0;
      height: 32px;
      border-top: #CCCCCC 1px solid;
      input {
        width: 100%;
        height: 32px;
        border: none;
        padding: 0 8px;
        line-height: 32px;
      }
    }
    transition: all 0.3s;

    &.shake-active {
      animation: chatshake 0.1s;
      animation-iteration-count: 3;
    }
  }

  @keyframes chatshake {
    0% {
      margin-right: 0;
    }
    25% {
      margin-right: 5px;
    }
    50% {
      margin-right: 0;
    }
    75% {
      margin-right: -5px;
    }
    100% {
      margin-right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// ChatConversa.vue?42f45668